export const SIGN_IN_PATH = '/sign-in'
export const HOME_PATH = '/home'
